import { useState } from '#imports'

import { HEADERS } from '@backmarket/nuxt-module-http-v2/constants'
import {
  AMPLITUDE_DEVICE_ID_STATE_KEY,
  AMPLITUDE_SESSION_ID_STATE_KEY,
} from '@backmarket/nuxt-module-tracking/amplitude/constants'

import { FORWARDED_APP_PLATFORM_STATE_KEY } from '~/constants/forwardedAppPlatform'

export function getShoppingAssistantForwardedHeaders(): Record<string, string> {
  const headers: Record<string, string> = {}
  const amplitudeDeviceId = useState<string | undefined>(
    AMPLITUDE_DEVICE_ID_STATE_KEY,
  ).value
  const amplitudeSessionId = useState<number | undefined>(
    AMPLITUDE_SESSION_ID_STATE_KEY,
  ).value
  const forwardedAppPlatform = useState<string | undefined>(
    FORWARDED_APP_PLATFORM_STATE_KEY,
  ).value

  if (amplitudeDeviceId) {
    headers[HEADERS.AMPLITUDE_DEVICE_ID] = amplitudeDeviceId
  }
  if (amplitudeSessionId) {
    headers[HEADERS.AMPLITUDE_SESSION_ID] = amplitudeSessionId.toString()
  }
  if (forwardedAppPlatform) {
    headers[HEADERS.APP_PLATFORM] = forwardedAppPlatform
  }

  return headers
}
